import { Button, Card, CardContent, CardHeader, Typography } from '@mui/material';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import DownloadFileContainer from '../../../../components/DownloadFileContainer';
import Header from '../../../../components/Header';
import Certificate from './Student.Certificate';

export default function MySolution({ onBack, testDetails }) {
  const { testMark, totalMark, markedDone } = testDetails;
  const [isCertificate, setIsCertificate] = useState(false);
  return !isCertificate ? (
    <div style={{ marginTop: 20 }}>
      <Header title="My Solution" onBack={onBack} />
      <Card style={{ marginTop: 15 }}>
        <CardContent>
          <DownloadFileContainer title="Class Test paper 1.pdf" />
        </CardContent>
      </Card>
      {markedDone && (
        <Card style={{ marginTop: 15 }}>
          <CardHeader title="Assign Marks" />
          <CardContent>
            <Typography>
              {testMark} out of {totalMark}
            </Typography>
          </CardContent>
        </Card>
      )}
      {markedDone && (
        <Card style={{ marginTop: 15 }}>
          <CardHeader title="Comment" />
          <CardContent>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Justo vel rhoncus non quis duis
            orci, quis. In bibendum orci, nec odio cum pellentesque. Pellentesque eget elit, neque,
            pellentesque ipsum scelerisque faucibus fermentum. Ipsum odio augue magnis lacinia odio
            egestas vestibulum, diam.
          </CardContent>
        </Card>
      )}
      {markedDone && (
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: 15 }}>
          <Button onClick={() => setIsCertificate(true)} variant="outlined">
            VIEW CERTIFICATE
          </Button>
        </div>
      )}
    </div>
  ) : (
    <Certificate onBack={() => setIsCertificate(false)} />
  );
}

MySolution.propTypes = {
  onBack: PropTypes.func,
  testDetails: PropTypes.shape({
    testMark: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    totalMark: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    markedDone: PropTypes.bool
  })
};
